import create from "zustand";
import { BASE_URL } from "../Global";
import useAuthStore from "./AuthStore";
import {
  addEventAPI,
  fetchEventsAPI,
  AddGiftToEventOrSpaceAPI,
  DeleteGiftFromEventOrSpaceAPI,
} from "../Services/eventService.js";
import { likeProductAPI } from "../Services/giftService.js";

const useEventStore = create((set, get) => ({
  events: [],
  spaces: [],
  loggedIn: localStorage.getItem("loggedin") === "true",
  setEvents: (events) => set({ events }),
  setSpaces: (spaces) => set({ spaces }),
  setLoggedIn: (status) => set({ loggedIn: status }),

  prompt: localStorage.getItem("prompt"),

  showPopup: false,
  popupMessage: "",
  popupImageUrl: null,
  popupLocation: "",
  popupType: "",
  setPopup: (message, imageUrl, location, type) => {
    set({
      showPopup: true,
      popupMessage: message,
      popupImageUrl: imageUrl || null,
      popupLocation: location,
      popupType: type,
    });
    setTimeout(
      () => set({ showPopup: false, popupMessage: "", popupImageUrl: null }),
      2200
    ); // Hide after 1 second
  },
  hidePopup: () =>
    set({ showPopup: false, popupMessage: "", popupImageUrl: null }),

  handleAddingNewSpaceOrEvent: async (type, event, space) => {
    const { setEvents, loggedIn } = get(); // Use get to access the store state

    if (loggedIn) {
      const response = await addEventAPI(event, space, type);
      return response;
    } else {
      const eventData = JSON.parse(localStorage.getItem("eventData")) || [];
      const spaceData = JSON.parse(localStorage.getItem("spaceData")) || [];

      if (type === "events") {
        const isDuplicateEvent = eventData.some(
          (storedEvent) =>
            storedEvent.eventName === event.eventName &&
            storedEvent.eventDate === event.eventDate
        );
        if (isDuplicateEvent) {
          return 400;
        } else {
          eventData.push(event);
          localStorage.setItem("eventData", JSON.stringify(eventData));
          console.log(
            "Saved event to localStorage:",
            JSON.stringify(eventData, null, 2)
          );
          return "successfully added";
        }
      } else if (type === "spaces") {
        const isDuplicateSpace = spaceData.some(
          (storedSpace) => storedSpace.spaceName === space.spaceName
        );
        if (isDuplicateSpace) {
          return 400;
        } else {
          spaceData.push(space);
          localStorage.setItem("spaceData", JSON.stringify(spaceData));
          console.log(
            "Saved space to localStorage:",
            JSON.stringify(spaceData, null, 2)

          );
          return "successfully added";
        }
      }
    }
  },

  handleFetchEvents: async () => {
    const { setEvents, setSpaces, loggedIn } = get(); // Use get to access the store state
    try {
      if (localStorage.getItem("loggedin") === "true") {
        const response = await fetchEventsAPI();
        setEvents(response.events);
        setSpaces(response.spaces);
      } else {
        const eventData = localStorage.getItem("eventData");
        if (eventData) {
          setEvents(JSON.parse(eventData));
        }
        const spaceData = localStorage.getItem("spaceData");
        if (spaceData) {
          setSpaces(JSON.parse(spaceData));
        }
      }
    } catch (error) {
      console.error("Error fetching events:", error);
    }
  },

  addProductToEvent: async (type, name, giftID) => {
    get().handleFetchEvents();
    const { events, spaces, loggedIn } = get(); // Use get to access the store state
    const { prompt } = get();
    try {
      if (localStorage.getItem("loggedin") === "true") {
        const response = await AddGiftToEventOrSpaceAPI(type, name, [giftID, window.localStorage.getItem("prompt")]);

        if (response.ok) {
          // Handle success
        } else {
          console.error("Failed to update event data.");
        }
      } else {
        const updatedItems = type === "events" ? [...events] : [...spaces];
        const existingItem = updatedItems.find(
          (item) =>
            (type === "events" ? item.eventName : item.spaceName) === name
        );

        if (existingItem) {
          const updatedGiftID = [
            ...(existingItem.giftID || []),
            [giftID, prompt],
          ];
          existingItem.giftID = updatedGiftID;
          localStorage.setItem(
            type === "events" ? "eventData" : "spaceData",
            JSON.stringify(updatedItems)
          );
          set({ [type === "events" ? "events" : "spaces"]: updatedItems });
        } else {
          console.error(
            `Item with the specified name ${name} does not exist in ${type}.`
          );
        }
      }
    } catch (error) {
      console.error("Error updating event data:", error);
    }
  },

  removeProductFromEvent: async (type, name, giftID) => {
    const { events, spaces, loggedIn } = get(); // Use get to access the store state
    // const eventName = "aboahmeden";
    const { prompt } = get();
    try {
      if (localStorage.getItem("loggedin") === "true") {
        const response = await DeleteGiftFromEventOrSpaceAPI(type, name, giftID);

        if (response.ok) {
          // Handle success
        } else {
          console.error("Failed to delete product from event.");
        }
      } else {
        const updatedItems = type === "events" ? [...events] : [...spaces];
        const existingItemIndex = updatedItems.findIndex(
          (item) =>
            (type === "events" ? item.eventName : item.spaceName) === name
        );

        if (existingItemIndex !== -1) {
          const existingItem = updatedItems[existingItemIndex];
          const updatedGiftID =
            existingItem.giftID?.filter((ids) => !ids.includes(giftID)) || [];
          existingItem.giftID = updatedGiftID;
          localStorage.setItem(
            type === "events" ? "eventData" : "spaceData",
            JSON.stringify(updatedItems)
          );
          set({ [type === "events" ? "events" : "spaces"]: updatedItems });
        } else {
          console.error(
            `Item with the specified name does not exist in ${type}.`
          );
        }
      }
    } catch (error) {
      console.error("Error deleting product from event:", error);
    }
  },


  likeGift: async (giftID) => {
    try {
      await likeProductAPI(giftID);
    } catch (error) {
      console.error("Error liking gift:", error);
    }
  },
}));

export default useEventStore;
